import React from 'react';
import { motion } from 'framer-motion';
import './PageHero.css';

export default function PageHero({ title, subtitle, badge, image }) {
    return (
        <div className="page-hero">
            <div className="page-hero-bg-wrapper">
                <img
                    src={image}
                    className="page-hero-img"
                    alt={title}
                />
                <div className="page-hero-overlay"></div>
            </div>
            <div className="container page-hero-content">
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                >
                    {badge && <span className="hero-badge">{badge}</span>}
                    <h1>{title}</h1>
                    {subtitle && <p>{subtitle}</p>}
                </motion.div>
            </div>
        </div>
    );
}
